module.exports = __webpack_public_path__ + "static/media/embeded.d1b34547.svg";